module.exports = __webpack_public_path__ + "static/programing-7cc91c544226d0b7d14a0a2f7cd88def.mp4";